import MonthYearPicker from './MonthYearPicker';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(MonthYearPicker);
